import { z } from 'zod'
import { Temporal } from '@js-temporal/polyfill'
import type { UserSession } from '../../models/UserSession'
import { createPlainDateTimeSafe } from '~/shared/composables/useTemporal'

export const UserSessionDTO = z.object({
  id: z.string().optional(),
  user_name: z.string(),
  ip_address: z.string().nullish(),
  user_agent: z.string().nullish(),
  last_accessed_at: z.string().nullish(),
  expires_at: z.string().datetime(),
  created_at: z.string().datetime()
})

export type UserSessionDTO = z.infer<typeof UserSessionDTO>

export function mapUserSessionToDTO (model: UserSession): UserSessionDTO {
  return {
    id: model.id,
    user_name: model.userName,
    ip_address: model.ipAddress,
    user_agent: model.userAgent,
    last_accessed_at: model.lastAccessedAt?.toString(),
    expires_at: model.expiresAt.toString(),
    created_at: model.createdAt.toString()
  }
}

export function mapDTOToUserSession (dto: UserSessionDTO): UserSession {
  return {
    id: dto.id,
    userName: dto.user_name ?? '',
    ipAddress: dto.ip_address ?? '',
    userAgent: dto.user_agent ?? '',
    lastAccessedAt: createPlainDateTimeSafe(dto.last_accessed_at),
    expiresAt: createPlainDateTimeSafe(dto.expires_at) ?? Temporal.Now.plainDateTimeISO(),
    createdAt: createPlainDateTimeSafe(dto.created_at) ?? Temporal.Now.plainDateTimeISO()
  }
}
